// Çapraz-kanal çift giriş onayı için ortak mesaj biçimleyici (DRY).
// Fatura girişi ve GRN onay sayfaları aynı metni kullanır.
// Girdi: backend'in döndürdüğü cakismalar dizisi
//   [{ kanal, belge_no, tarih, miktar, malzeme_id, malzeme_ad }]
export function ciftGirisOnayMetni(cakismalar) {
  if (!cakismalar || cakismalar.length === 0) return '';
  return cakismalar
    .map((c) => `• ${c.malzeme_ad || 'Malzeme'}: ${c.tarih} · ${c.belge_no} · ${c.miktar}`)
    .join('\n');
}
